<template>
    <div class="home_area">

        <div class="full_content_area home_top_area_div">
            <a name="home_top" class="a_shortcut_fix" />

            <div class="banner_div">
                <!-- banner start -->
                <div class="banner_area display_desktop">
                    <div class="banner_area_slide_area display_desktop isInherit" ref="slide" v-if="banners.length>0">
                        <div class="banner_area_slide_outer_div" v-for="(banner,index) in banners" :key="index">
                            <div class="banner_area_slide" :style="{backgroundImage: 'url(\'' + banner.src + '\')'}">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="banner_area display_responsive">
                    <div class="banner_area_slide_area display_responsive isInherit" ref="slide_resp" v-if="banners.length>0">
                        <div class="banner_area_slide_outer_div" v-for="(banner,index) in banners" :key="index">
                            <img :src="banner.src_resp" class="img-fluid" />
                        </div>
                    </div>
                </div>
                <!-- banner end -->
            </div>

            <div class="home_address_main_div">
                <div class="address_search_div" v-if="$root.CheckOrderModeIsShopping">
   
                    <div class="order_type_title">{{label['shopping_mode_delivery_method_title']}}</div>
                    <div class="order_type_tag_div">
                        <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('delivery') >= 0" :class="{active : $root.info.order_temp_info.order_type == 'delivery'}" @click="$root.changeOrderType('delivery')">{{$root.GetOrderModePickupTypeLabel(1)}}</div>
                        <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('pickup') >= 0" :class="{active : $root.info.order_temp_info.order_type == 'pickup'}" @click="$root.changeOrderType('pickup')">{{$root.GetOrderModePickupTypeLabel(2)}}</div>
                        <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('pickupShop') >= 0" :class="{active : $root.info.order_temp_info.order_type == 'pickupShop'}" @click="$root.changeOrderType('pickupShop')">{{$root.GetOrderModePickupTypeLabel(3)}}</div>
                    </div>
                    <div class="order_type_tag_remarks_div" v-html="$root.GetHomeOrderModeOrderTypeRemarksLabel()">
                    </div>

                    <div class="order_time_div" v-if="$root.info.order_temp_info.order_date_list.length > 1">
                        <div class="order_time_title">{{label['modify_order_info_select_date_title']}}</div>
                        <div class="order_time_option_div">
                             <div class="order_time_option one_tag">
                                <select class="" @change="$root.changeOrderDate($event)">
                                    <option class=""
                                            v-for="(i, index) in $root.info.order_temp_info.order_date_list"
                                            :value="i"
                                            :selected="i == info.order_temp_info.order_date">
                                        {{ $root.OrderDateTagTextDisplay(i) }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="order_time_div" v-if="info.order_setting.order_time_select && $root.info.order_temp_info.order_date_list.length > 1">
                        <div class="order_time_title">{{label['modify_order_info_select_datetime_title']}}</div>
                        <div class="order_time_option_div">
                            <div class="order_time_option one_tag">
                                <select class="" @change="$root.changeOrderTime($event)">
                                    <option class=""
                                            v-for="(i, index) in $root.info.order_temp_info.order_time_list"
                                            :value="i"
                                            :selected="i == info.order_temp_info.order_time">
                                        {{ i == "asap" ? label["order_time_option_asap"] : i }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                    <!-- add !CheckOrderModeIsShopping on 20260715 for moving input address select shop to confirmation page -->
                    <div style="width:100%" v-if="$root.info.order_temp_info.order_type != 'pickup' && $root.info.order_temp_info.order_type != 'pickupShop' && !$root.CheckOrderModeIsShopping">
                        <div class="order_address_div">
                            <div class="order_address_title" v-if="!$root.CheckOrderModeIsShopping">{{label['modify_order_info_address_text']}}</div>
                            <div class="order_address_title" v-if="$root.CheckOrderModeIsShopping">{{label['modify_order_info_address_text']}}{{label['home_delivery_address_remark_text']}}</div>
                            <div class="order_address_sub_text" v-if="!$root.CheckOrderModeIsShopping">{{label['modify_order_info_address_search_shop_text']}}</div>

                            <div class="address_input_div" :class="{select : $root.info.order_temp_info.order_address_type == 'search'}">
                                <div class="pointer_area" @click="$root.SearchAddressPositionLL('home_search_address_text','home')"></div>
                                <div class="input_area" :class="{inSearch : $root.isSearchAddressFocus}">
                                    <input autocomplete="off" type="text" value="" class="" :placeholder="label['search_address_building_text']" id="home_search_address_text" @keyup="$root.SearchAddressText($event,'home')" @focus="$root.SearchAddressFocus($event,'home')" @blur="$root.SearchAddressBlur($event,'home')" />
                                </div>
                                <div class="cancel_area_div" v-if="$root.isSearchAddressFocus">
                                    <div class="cancel_area" @click="$root.SearchAddressCancel()"></div>
                                </div>
                                <div class="cancel_area_div search_icon" v-if="$root.isSearchAddressFocus">
                                    <div class="cancel_area" @click="$root.SearchAddressText($event,'home')"></div>
                                </div>
                            </div>
                        </div>

                        <div class="order_address_for_member" v-if="cart.member != null && cart.memberAddress.length > 0">
                            <div class="order_address_header">{{label['modify_order_info_select_address_or_text']}}</div>

                            <div class="order_address_sub_text_area">
                                <div class="order_address_sub_text" style="width:auto;">{{label['modify_order_info_member_search_default_address_text']}}</div>
                                <div class="order_address_select_address" @click="$root.modifyAddressOpen('home',$root.ModifyAddressLayerHeaderText())">{{label['modify_order_info_member_select_other_address_text']}}</div>
                            </div>

                            <div class="select_address_area" :class="{select : $root.info.order_temp_info.order_address_type == 'member'}" @click="$root.ChangeOrderAddressType('member')">

                                <div class="address_display_div" v-for="(add, index) in $root.address_list.filter(a => a.address_type == 'member' && a.isMemberSelect)">
                                    <div class="address_display_contact">
                                        <span v-if="add.address_tag != undefined && add.address_tag != ''">{{add.address_tag}}．</span>{{add.contact_info['name']}}．+{{add.contact_info['tel_countryCode']}}-{{add.contact_info['tel']}}
                                    </div>
                                    <div class="address_display_address">{{add.address['address_full_'+info.lang]}}</div>                                    
                                </div>

                            </div>
                        </div>
                    </div>

                    <div style="width:100%" v-if="$root.checkHomeEnableSelectAreaDistrict()">
                        <div class="order_shop_district_select_div">
                            <!-- add !CheckOrderModeIsShopping on 20260715 for moving the select to confirmation page -->
                            <div class="order_shop_select_title" v-if="!$root.CheckOrderModeIsShopping">{{label['home_shop_district_select_title_text']}}</div>
                            <div class="order_shop_select_option_div">
                                <div class="order_shop_select_option">
                                    
                                    <!-- for order select area and district start -->
                                    <div class="order_shop_select_option_select_div left_div" v-if="!$root.CheckOrderModeIsShopping">
                                        <select class="" @change="$root.ChangeSelectShopDistrictArea($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_area_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(s, index) in $root.AllShopDistrictList"
                                                    :value="s.areaCode"
                                                    :selected="s.areaCode == $root.homeSelectShop.homeSelectShopArea">
                                                {{ s['areaName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="order_shop_select_option_select_div right_div" v-if="!info.order_setting.pickupShopAreaFilter && !$root.CheckOrderModeIsShopping">
                                        <select class="" v-if="!info.order_setting.pickupShopAreaFilter" @change="$root.ChangeSelectShopDistrictAreaDistrict($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_district_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(d, index) in $root.homeSelectShop.homeSelectShopAreaDistrictList"
                                                    :value="d.districtCode"
                                                    :selected="d.districtCode == $root.homeSelectShop.homeSelectShopDistrict">
                                                {{ d['districtName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- for order select area and district end -->

                                    <!-- for order select area only start -->
                                    <div class="order_shop_select_option_select_div left_div" v-if="info.order_setting.pickupShopAreaFilter && !$root.CheckOrderModeIsShopping" :class="{isfull: info.order_setting.pickupShopAreaFilter}">
                                        <select class="" @change="$root.ChangeSelectShopDistrictAreaList($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_area_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(s, index) in $root.AllShopDistrictList"
                                                    :value="s.areaCode"
                                                    :selected="s.areaCode == $root.homeSelectShop.homeSelectShopArea">
                                                {{ s['areaName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- for order select area only end -->

                                    <!-- for shopping pickup locker start -->
                                    <!-- hide on 20260715 for moving the select to confirmation page -->
                                    <!--<div class="order_shop_select_option_select_div left_div" v-if="$root.getCurrentOrderTypeSubfix == '2' && $root.CheckOrderModeIsShopping">
                                        <select class="" @change="$root.ChangeSelectShoppingDistrictArea($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_area_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(s, index) in $root.shoppingDistrictList"
                                                    :value="s.areaCode"
                                                    :selected="s.areaCode == $root.homeSelectShop.homeSelectShopArea">
                                                {{ s['areaName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="order_shop_select_option_select_div right_div" v-if="$root.getCurrentOrderTypeSubfix == '2' && $root.CheckOrderModeIsShopping">
                                        <select class="" @change="$root.ChangeSelectShopDistrictAreaDistrict($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_district_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(d, index) in $root.homeSelectShop.homeSelectShopAreaDistrictList"
                                                    :value="d.districtCode"
                                                    :selected="d.districtCode == $root.homeSelectShop.homeSelectShopDistrict">
                                                {{ d['districtName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- for shopping pickup locker end -->

                                    <!-- for shopping pickupShop start -->
                                    <!-- hide on 20260715 for moving the select to confirmation page -->
                                    <!--<div class="order_shop_select_option_select_div left_div" v-if="$root.getCurrentOrderTypeSubfix == '3' && $root.CheckOrderModeIsShopping">
                                        <select class="" @change="$root.ChangeSelectShopDistrictArea($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_area_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(s, index) in AllShopDistrictListPickupShop"
                                                    :value="s.areaCode"
                                                    :selected="s.areaCode == $root.homeSelectShop.homeSelectShopArea">
                                                {{ s['areaName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="order_shop_select_option_select_div right_div" v-if="$root.getCurrentOrderTypeSubfix == '3' && !info.order_setting.pickupShopAreaFilter && $root.CheckOrderModeIsShopping">
                                        <select class="" v-if="!info.order_setting.pickupShopAreaFilter" @change="$root.ChangeSelectShopDistrictAreaDistrict($event)">
                                            <option class="" value="">
                                                {{label['home_shop_district_select_please_select_district_text']}}
                                            </option>
                                            <option class=""
                                                    v-for="(d, index) in $root.homeSelectShop.homeSelectShopAreaDistrictList"
                                                    :value="d.districtCode"
                                                    :selected="d.districtCode == $root.homeSelectShop.homeSelectShopDistrict">
                                                {{ d['districtName'+getItemSubfix()] }}
                                            </option>
                                        </select>
                                    </div>-->
                                    <!-- for shopping pickupShop end -->

                                </div>
                            </div>
                        </div>

                        <!-- hide for Tenren select shop by select -->
                        <!--
                        <div class="order_shop_district_select_div">
                            <div class="order_shop_select_title">{{label['home_shop_list_select_title_text']}}</div>
                            <div class="order_shop_select_option_div">
                                <div class="order_shop_select_option">
                                    <select class="" @change="$root.changeSelectShopList($event)">
                                        <option class="" value="">
                                            {{label['home_shop_list_select_please_select_text']}}
                                        </option>
                                        <option class=""
                                                v-for="(s, index) in $root.homeSelectShop.homeSelectShopList"
                                                :value="s.shopCode"
                                                :selected="s.shopCode == $root.homeSelectShop.homeSelectedShopList">
                                            {{ s['name'+getItemSubfix()] }} - {{ s['address'+getItemSubfix()] }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        -->
                    </div>

                    <div class="order_address_confirm_div">
                        <div class="order_address_confirm_btn" :class="{active: checkHomeConfirmBtnEnable()}" @click="selectDefaultBrand()">{{label['modify_order_info_confirm_text']}}</div>
                    </div>

                </div>

                <!-- for order select shop on home page start -->
                <div class="address_search_div address_search_div_full_width" v-if="!$root.CheckOrderModeIsShopping">
                    <div class="full_width_area no_border" v-if="$root.memberPreferShopList.length > 0">
                        <div class="home_select_shop_header" :class="{open: current_home_select_shop_type == 'prefer'}" @click="HomeSelectShopTypeClick('prefer')">
                            <div class="header_div">{{label['home_header_prefer_shop']}}</div>
                            <div class="arrow_div"></div>
                        </div>
                        <transition name="sliderDivFast">
                            <div class="home_shop_select_div padding_width">
                                <div class="home_shop_select_div" v-if="current_home_select_shop_type == 'prefer'">

                                    <div class="home_shop_select_row" :class="{inactive: !s.isOpen}" v-for="(s, index) in $root.memberPreferShopList">
                                        <div class="shop_info_div">
                                            <div class="shop_name">
                                                <div class="shop_like_div" :class="{active: $root.CheckMemberPreferShopcontainsShopCode(s.shopCode_global)}" @click="$root.UpdateMemberPreferShopCode(s.shopCode_global)">
                                                </div>
                                                <div class="shop_text" @click="clickHomeAllShopList(s)">
                                                    {{ s["name" + getItemSubfix()] }}
                                                </div>
                                            </div>
                                            <div class="shop_address" @click="clickHomeAllShopList(s)">
                                                {{ s["address" + getItemSubfix()] }}
                                            </div>
                                        </div>
                                        <div class="arrow_div" @click="clickHomeAllShopList(s)"></div>
                                    </div>

                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="full_width_area no_border">
                        <div class="home_select_shop_header" :class="{open: current_home_select_shop_type == 'normal'}" @click="HomeSelectShopTypeClick('normal')">
                            <div class="header_div">{{label['home_header_shop_select']}}</div>
                            <div class="arrow_div"></div>
                        </div>
                        <transition name="sliderDivFast">
                            <div class="full_width_area padding_width no_border" v-if="current_home_select_shop_type == 'normal'">
                                <div class="full_width_area">
                                    <div class="order_shop_district_select_div">
                                        <div class="order_shop_select_title">{{label['home_shop_district_select_title_text']}}</div>
                                        <div class="order_shop_select_option_div">
                                            <div class="order_shop_select_option">

                                                <div class="order_shop_select_option_select_div left_div">
                                                    <select class="" @change="ChangeHomeAllShopListSelectShopDistrictArea($event)">
                                                        <option class="" value="">
                                                            {{label['home_shop_district_select_please_select_area_text']}}
                                                        </option>
                                                        <option class=""
                                                                v-for="(s, index) in $root.AllShopDistrictList"
                                                                :value="s.areaCode"
                                                                :selected="s.areaCode == $root.homeSelectShop.homeSelectShopArea">
                                                            {{ s['areaName'+getItemSubfix()] }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="order_shop_select_option_select_div right_div">
                                                    <select class="" v-if="!info.order_setting.pickupShopAreaFilter" @change="ChangeHomeAllShopListSelectShopDistrictAreaDistrict($event)">
                                                        <option class="" value="">
                                                            {{label['home_shop_district_select_please_select_district_text']}}
                                                        </option>
                                                        <option class=""
                                                                v-for="(d, index) in $root.homeSelectShop.homeSelectShopAreaDistrictList"
                                                                :value="d.districtCode"
                                                                :selected="d.districtCode == $root.homeSelectShop.homeSelectShopDistrict">
                                                            {{ d['districtName'+getItemSubfix()] }}
                                                        </option>
                                                    </select>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="full_width_area no_border">
                                    <div class="home_shop_select_div" v-if="HomeSelectShopList.length > 0">

                                        <div class="home_shop_select_row" :class="{inactive: !s.isOpen}" v-for="(s, index) in HomeSelectShopList" @click="clickHomeAllShopList(s)">
                                            <div class="shop_info_div">
                                                <div class="shop_name">
                                                    <div class="shop_distance" v-if="s.distance > -1">
                                                        {{s.distance + ' ' + label['shop_list_km_label']}}
                                                    </div>
                                                    {{ s["name" + getItemSubfix()] }}
                                                </div>
                                                <div class="shop_address">
                                                    {{ s["address" + getItemSubfix()] }}
                                                </div>
                                            </div>
                                            <div class="arrow_div"></div>
                                        </div>

                                    </div>

                                    <div class="home_shop_select_div" v-if="HomeSelectShopList.length <= 0">

                                        <div class="home_shop_select_row">
                                            <div class="shop_info_div full">
                                                <div class="shop_name">
                                                    {{label["shop_list_shop_not_found"]}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>

                </div>
                <!-- for order select shop on home page end -->

            </div>
            <!-- home_address_main_div -->
            
        </div>
        <!-- home_top_area_div end -->
        

    </div>
</template>
 
<script>
    import MiddlePageTopMenuBar from "../components/MiddlePageTopMenuBar.vue";

    export default {
        data() {
            return {
                banners:[],
                NewPromoteList: [],
                FoodPromoteList: [],

                HomeSelectShopListAll: [],
                HomeSelectShopList: [],

                AllShopDistrictListPickupShop: [],

                current_home_select_shop_type: ''
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            }
        },
        components: { MiddlePageTopMenuBar },
        created() {
            var app = this;

            app.check_home_select_shop_type();

            // prevent cannot scroll when loading the page
            this.$root.setBodyOverflow(false);
            this.info.itemMenuDetailsOpen = false;

            this.$root.getCurrentPathName();
            this.info.loading = false;

            if (allBanner["home"]) this.banners = allBanner["home"];
            if (this.$root.CheckOrderModeIsShopping) {
                if (allBanner["homeShopping"]) this.banners = allBanner["homeShopping"];
            }

            this.$nextTick(function () {
                if (this.$refs.slide) {
                    $(this.$refs.slide).slick({
                        adaptiveHeight: true,
                        autoplay: true,
                        arrows: false,
                        dots:false
                    });
                }
            });
            this.$nextTick(function () {
                if (this.$refs.slide_resp) {
                    $(this.$refs.slide_resp).slick({
                        adaptiveHeight: true,
                        autoplay: true,
                        arrows: false,
                        dots: false
                    });
                }
            });

            //get promote json start
            $.get(
                "/files/home_promote.json",
                data => {
                    $.each(data.new_promote, (i, o) => {
                        this.NewPromoteList.push(o);
                    });
                    $.each(data.food_promote, (i, o) => {
                        this.FoodPromoteList.push(o);
                    });
                },
                "JSON"
            );
            //get promote json end

            /*
            if (this.cart != null && this.cart.shopDistrict != "" && this.cart.shop != null) {
                this.$root.homeSelectShop.homeSelectShopDistrict = this.cart.shopDistrict + "";
                this.$root.homeSelectShop.homeSelectedShopList = this.cart.shop.shopCode;
                this.$root.ChangeSelectShopDistrictFilter();
            }
            */
            /*
            if (this.cart != null && this.cart.shopDistrict != "") {
                this.$root.homeSelectShop.homeSelectShopDistrict = this.cart.shopDistrict + "";
            }
            */

            // filter select area for pickupShop
            $.each(this.$root.AllShopDistrictList, (i, s) => {
                var temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && s2.shopCode.includes("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) && (s2.areaCode == s.areaCode)));
                if (temp_shop.length > 0)
                    app.AllShopDistrictListPickupShop.push(s);
            });

            if (this.cart != null && this.cart.shopArea != "") {
                this.$root.homeSelectShop.homeSelectShopArea = this.cart.shopArea + "";
                this.$root.homeSelectShop.homeSelectShopDistrict = this.cart.shopDistrict + "";
                this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];
            }
            if (this.$root.homeSelectShop.homeSelectShopArea != "") {
                if (this.$root.CheckOrderModeIsShopping) {
                    if (this.$root.getCurrentOrderTypeSubfix == '3') {
                        this.$root.ChangeSelectShopDistrictAreaFilter();
                    }
                    else {
                        this.$root.ChangeSelectShoppingDistrictAreaFilter();
                    }
                } else {
                    this.$root.ChangeSelectShopDistrictAreaFilter();
                }
            }

            if (this.info.order_temp_info.temp_default_shop_isInit && this.checkHomeConfirmBtnEnable()) {
                this.info.order_temp_info.temp_default_shop_isInit = false;
                this.selectDefaultBrand();
            }
            else {

                // tenren load shop on home page
                if (this.info.order_temp_info.order_mode == "order") {
                    this.getHomeAllShopList();
                }

            }            
        },
        destroyed() {
        },
        beforeDestroy() {
            if (this.$refs.slide) {
                try {
                    $(this.$refs.slide).slick("unslick");
                } catch(e) {}
            }
            if (this.$refs.slide_resp) {
                try {
                    $(this.$refs.slide_resp).slick("unslick");
                } catch (e) { }
            }
        },
        mounted() {
            this.getHomeOrderAddressTempInfo();
        },
        watch: {
            '$root.currentPositionLL': function () {
                this.FilterAllShopListAreaDistrict();
            }
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },

            getHomeOrderAddressTempInfo() {
                var app = this;
                try {

                    if (this.$root.info.order_temp_info.order_type == 'pickup' || this.$root.info.order_temp_info.order_type == 'pickupShop') {
                    }
                    else {

                        if (this.info.order_temp_info.order_address_type == "search") {
                            if (this.info.order_temp_info.order_address != null) {
                                var target_id = "home_search_address_text";
                                var target = this.$el.querySelector("#" + target_id);
                                target.value = this.info.order_temp_info.order_address["address_" + this.info.lang];
                                $(target).data("oldValue", this.info.order_temp_info.order_address);
                            }
                        } else if (this.info.order_temp_info.order_address_type == "member") {

                        }

                    }

                } catch (e) {
                    console.log(e);
                    window.setTimeout(app.getHomeOrderAddressTempInfo, 200);
                }
            },

            selectBrand(brand) {
                this.info.loading = true;
                this.cart.loadCart(); // run loadCart to check cart timeout
                this.$root.setSelectBrand(brand, null);                

                //if (this.$root.info.order_temp_info.order_mode == 'smallPoonChoi') {
                if (this.$root.info.order_temp_info.order_type == 'pickup') {

                    // get all shop list start
                    /*
                    var search_address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address_sample));
                    search_address["address_full_zh"] = this.cart.shop.address1;
                    search_address["address_full_en"] = this.cart.shop.address2;
                    search_address["address_full_sc"] = this.cart.shop.address3;
                    search_address["address_zh"] = this.cart.shop.address1;
                    search_address["address_en"] = this.cart.shop.address2;
                    search_address["address_sc"] = this.cart.shop.address3;
                    search_address["location"] = this.cart.shop.location[0] + "," + this.cart.shop.location[1];
                    this.info.order_temp_info.order_address = search_address;
                    var address_ll = this.cart.shop.location;
                    */
                    this.$root.getShopList(this.HomeGoShopList);
                    // get all shop list end

                }
                else if (this.$root.CheckOrderModeIsShopping && this.$root.info.order_temp_info.order_type == 'pickupShop') {                    
                    this.pickUpShopSelect();
                }
                else {
                    this.$root.UpdateCurrentAddressList(true);

                    // get shop list start
                    if (this.$root.info.order_setting.skipZeekShopList) {
                        this.$root.getShopList(this.HomeGoShopList);
                    }
                    else {
                        var address_ll = (this.info.order_temp_info.order_address.location + "").split(',');
                        this.$root.getShopListByLL(address_ll[0], address_ll[1], this.HomeGoShopList);
                    }
                    // get shop list end
                }

                //this.info.loading = false;
            }, // selectBrand end
            selectDefaultBrand() {
                this.$root.SearchAddressCancel();
                if (this.checkHomeConfirmBtnEnable()) {
                    this.$root.homeSelectShopListConfirm();
                    this.selectBrand(JSON.parse('{"brandCode":"defaultBrand"}'));
                }
            },
            checkHomeConfirmBtnEnable() {
                // add !CheckOrderModeIsShopping on 20260715 for moving the select to confirmation page 
                if (!this.$root.CheckOrderModeIsShopping) {
                    if (this.info.order_temp_info.order_time != "---") {
                        /*
                        if (this.$root.info.order_temp_info.order_mode == 'smallPoonChoi') {
                            if (this.$root.homeSelectShop.homeSelectedShopList != "") {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        */
                        if (this.$root.info.order_temp_info.order_type == 'pickup' || this.$root.info.order_temp_info.order_type == 'pickupShop') {
                            //if (this.$root.homeSelectShop.homeSelectShopDistrict != "") {
                            if (this.$root.homeSelectShop.homeSelectShopDistrict != "" || (this.info.order_setting.pickupShopAreaFilter && this.$root.homeSelectShop.homeSelectShopArea != "")) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        else {
                            if (this.info.order_temp_info.order_address != null) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }

                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            HomeGoShopList(data) {
                var app = this;
                app.$root.LLShopList = data.shops;
                app.$root.setLLShopListStorage();
                /*
                //if (this.$root.info.order_temp_info.order_mode == 'smallPoonChoi' || this.$root.info.order_temp_info.order_mode == 'largePoonChoi') {
                if (this.$root.info.order_setting.skipZeekShopList) {
                    this.$router.push("shop");
                } else {
                    if (this.$root.LLShopList.length > 0) {
                        this.$router.push("shop");
                    }
                    else {
                        this.$root.alert("modify_order_info_no_shop_found_text");
                        this.info.loading = false;
                    }
                }
                */

                if (app.$root.LLShopList.length > 0) {
                    if (!app.$root.CheckOrderModeIsShopping) {
                        app.cart.shopArea = app.$root.homeSelectShop.homeSelectShopArea;
                        app.cart.shopDistrict = app.$root.homeSelectShop.homeSelectShopDistrict;
                    }
                    else {
                        app.cart.shopArea = null;
                        app.cart.shopDistrict = null;
                    }

                    if (app.$root.CheckOrderModeIsShopping)
                        app.cart.disableDiscount = false;

                    app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                    app.cart.saveCart();

                    app.$router.push("shop");
                }
                else {
                    app.$root.alert("modify_order_info_no_shop_found_text");
                    app.info.loading = false;
                }
            },

            getHomeAllShopList() {
                this.info.loading = true;

                this.$root.SearchAddressCancel();
                this.$root.homeSelectShopListConfirm();
                
                this.cart.loadCart(); // run loadCart to check cart timeout
                this.$root.setSelectBrand(JSON.parse('{"brandCode":"defaultBrand"}'), null);
                if (this.$root.info.order_temp_info.order_type == 'pickup') {
                    this.$root.getShopList(this.setHomeAllShopList);
                }
                else {
                    this.info.loading = false;
                }
            },
            setHomeAllShopList(data) {
                var app = this;
                //console.log("data", data);
                app.$root.LLShopList = data.shops;
                //console.log("app.$root.LLShopList", app.$root.LLShopList);
                app.$root.setLLShopListStorage();

                app.HomeSelectShopListAll = [];
                app.FilterAllShopListAreaDistrict();

                if (app.$root.reorder_temp_data.shop != null) {
                    let temp_shop = app.HomeSelectShopListAll.filter(s2 => (s2.shopCode_global == app.$root.reorder_temp_data.shop.shopCode_global));
                    if (temp_shop != null && temp_shop.length > 0 && temp_shop[0].isOnline) {
                        app.clickHomeAllShopList(temp_shop[0]);
                    }
                    else {
                        app.$root.alert("shop_current_not_available_text");
                        app.info.loading = false;
                    }
                } 
                else {
                    app.info.loading = false;
                }
            },
            clickHomeAllShopList(shop) {
                if (shop.isOpen) {
                    this.info.loading = true;

                    var app = this;
                    app.$root.homeSelectShop.homeSelectShopArea = shop.areaCode + "";
                    app.$root.homeSelectShop.homeSelectShopDistrict = shop.districtCode + "";
                    app.cart.shopArea = app.$root.homeSelectShop.homeSelectShopArea;
                    app.cart.shopDistrict = app.$root.homeSelectShop.homeSelectShopDistrict;

                    //app.info.order_temp_info.temp_default_shop = shop.shopCode_global + ""; // hide for prefer shop
                    app.info.order_temp_info.home_select_shop = shop.shopCode + "";
                    app.$root.setOrderTempInfoData();

                    if (app.$root.CheckOrderModeIsShopping)
                        app.cart.disableDiscount = false;

                    app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                    app.cart.saveCart();

                    app.$router.push("shop");
                }
            },
            ChangeHomeAllShopListSelectShopDistrictArea(ev) {
                this.$root.homeSelectShop.homeSelectShopArea = ev.target.value + "";
                this.$root.homeSelectShop.homeSelectShopDistrict = "";
                this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];
                if (this.$root.homeSelectShop.homeSelectShopArea != "")
                    this.ChangeHomeAllShopListSelectShopDistrictAreaFilter();

                this.FilterAllShopListAreaDistrict();
            },
            ChangeHomeAllShopListSelectShopDistrictAreaFilter() {
                var app = this;
                var temp_shop = app.$root.AllShopDistrictList.filter(s => s.areaCode == app.$root.homeSelectShop.homeSelectShopArea);
                if (temp_shop.length > 0) {
                    $.each(temp_shop[0].district, (i, s) => {
                        app.$root.homeSelectShop.homeSelectShopAreaDistrictList.push(s);
                    });
                }
            },
            ChangeHomeAllShopListSelectShopDistrictAreaDistrict(ev) {
                this.$root.homeSelectShop.homeSelectShopDistrict = ev.target.value + "";
                this.FilterAllShopListAreaDistrict();
            },
            FilterAllShopListAreaDistrict() {
                var app = this;
                app.HomeSelectShopList = [];

                if (app.HomeSelectShopListAll.length <= 0) {
                    var temp_shop = null;
                    var o = null;
                    var check_date = moment(app.$root.OrderDateSelectMenuTime);
                    var check_time = check_date.hour() * 100 + check_date.minute();
                    $.each(app.$root.LLShopList, (i, s1) => {
                        temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode)));
                        if (temp_shop.length > 0) {
                            o = temp_shop[0];
                            o.isOpen = false;
                            o.isOnline = s1.isOnline;
                            //if (o.visible != "y") o.isOnline = false; // not checking visible on tenren
                            o.distance = -1; // add distance on 20251217

                            if (o.isOnline) {
                                o.isOpen = app.cart.getShopOpen(o, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                            }

                            app.HomeSelectShopListAll.push(o);
                        }
                    });
                }

                app.HomeSelectShopList = JSON.parse(JSON.stringify(app.HomeSelectShopListAll));

                if (app.$root.homeSelectShop.homeSelectShopArea != "") {
                    app.HomeSelectShopList = app.HomeSelectShopList.filter(s2 => (s2.areaCode == app.$root.homeSelectShop.homeSelectShopArea));
                }

                if (app.$root.homeSelectShop.homeSelectShopDistrict != "") {
                    app.HomeSelectShopList = app.HomeSelectShopList.filter(s2 => (s2.districtCode == app.$root.homeSelectShop.homeSelectShopDistrict));
                }

                // not display visible shop for tenren
                app.HomeSelectShopList = app.HomeSelectShopList.filter(s2 => (s2.visible == "y"));
                
                // add google map distance on 20251217
                app.$root.setShopListDistance(app.HomeSelectShopList);

                /*
                app.HomeSelectShopList = app.HomeSelectShopList.sort(function (a, b) {
                    if (!a.isOpen && b.isOpen) { return 1; }
                    if (a.isOpen && !b.isOpen) { return -1; }
                    return 0;
                });
                */
                app.HomeSelectShopList = multiSort(app.HomeSelectShopList, { "isOpen": "desc", "distance": "asc" });
            },
            pickUpShopSelect() {
                var app = this;
                app.cart.shopArea = app.$root.homeSelectShop.homeSelectShopArea;
                app.cart.shopDistrict = app.$root.homeSelectShop.homeSelectShopDistrict;

                if (app.$root.CheckOrderModeIsShopping)
                    app.cart.disableDiscount = false;

                app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                app.cart.saveCart();
                app.$router.push("ShoppingPickup");
            },

            check_home_select_shop_type() {
                var app = this;
                var t = 'normal';
                if (!app.$root.CheckOrderModeIsShopping && app.info.order_temp_info.temp_default_shop == "") {
                    if (app.$root.memberPreferShopList.length > 0) {
                        t = 'prefer';
                        if (app.$root.memberPreferShopList.length > 1) {
                            // keep on home page when prefer shop list > 1
                        }
                        else {
                            if (app.info.order_temp_info.home_select_shop == "")
                                app.clickHomeAllShopList(app.$root.memberPreferShopList[0]);
                        }
                    }
                }
                app.current_home_select_shop_type = t;
            },
            HomeSelectShopTypeClick(t) {
                this.current_home_select_shop_type = t;
            }
            
        }
    }; // export default end
</script>
